import React from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  useTheme,
} from "@mui/material";

const ForgotPassword = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "90vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 4,
          width: "100%",
          maxWidth: 400,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Typography variant="h5" align="center" gutterBottom>
          Passwort vergessen?
        </Typography>

        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          Kein Problem – bitte melde dich einfach bei deinem Admin.
        </Typography>

        <Typography variant="body2" align="center" sx={{ mt: 1, mb: 3 }}>
          Daniel hilft dir gerne weiter und setzt dein Passwort für dich zurück.
        </Typography>

        <Button
          href="https://wa.me/4917632077830"
          target="_blank"
          variant="contained"
          fullWidth
        >
          Jetzt per WhatsApp schreiben
        </Button>
      </Paper>
    </Box>
  );
};

export default ForgotPassword;
